<app-juvo-dialog
  type="common-long"
  titleType="primary"
  [title]="translations['title'] || 'Terms and Conditions'"
  [showFooter]="showAcceptButtons"
  [showCancel]="true"
  [showConfirm]="true"
  [isStandaloneOverlay]="false"
  [cancelText]="translations['decline'] || 'Cerrar'"
  [confirmText]="translations['accept'] || 'Aceptar'"
  [showBottomBar]="false"
  (cancel)="onDecline()"
  (confirm)="onAccept()">

  <app-tabs
    class="block mb-3"
    [tabs]="tabs"
    [selectedTab]="selectedTab"
    displayMode="onlyText"
    (tabChange)="onTabChanged($event)">
  </app-tabs>

  <div class="h-22rem overflow-y-auto">
    <app-scroll-container class="block h-full" direction="vertical" size="auto" [showScrollable]="true">
      <div class="grid px-3 pb-3 pt-0 bg-transparent line-height-3">
        <div class="col-12" *ngIf="selectedTab === 'terms'">
          <div class="bg-transparent">
            <h5 class="font-bold text-justify mb-3 text-xl text-primary">
              {{ accountSlug }} {{ translations['titleTermsAndConditionsOfUse'] }}
            </h5>
            <ol class="text-justify m-0 pl-3 text-500">
              <li class="mb-3">
                {{ translations['contentTermsAndConditionsOfUse'] }}
                {{ accountSlug }}
                {{ translations['contentTermsAndConditionsOfUse1'] }}
                {{ accountSlug }}
                {{ translations['contentTermsAndConditionsOfUse12'] }}
                {{ accountSlug }}
                {{ translations['contentTermsAndConditionsOfUse13'] }}
              </li>

              <li class="mb-3">
                {{ translations['contentTermsAndConditionsOfUse2'] }}
                {{ accountSlug }}
                {{ translations['contentTermsAndConditionsOfUse21'] }}
                {{ accountSlug }}
                {{ translations['contentTermsAndConditionsOfUse22'] }}
                {{ accountSlug }}
                {{ translations['contentTermsAndConditionsOfUse23'] }}
              </li>

              <li class="mb-3">
                {{ translations['contentTermsAndConditionsOfUse3'] }}
                {{ accountSlug }}
                {{ translations['contentTermsAndConditionsOfUse31'] }}
              </li>
            </ol>
          </div>
        </div>

        <div class="col-12" *ngIf="selectedTab === 'shipping'">
          <div class="bg-transparent">
            <h5 class="font-bold text-justify mb-3 text-xl text-primary">{{ translations['titleShippingAndDeliveryPolicies'] }}</h5>
            <p class="text-justify mb-3 m-0 text-500">
              {{ accountSlug }}
              {{ translations['contentShippingAndDeliveryPolicies1'] }}
              {{ accountSlug }}{{ translations['contentShippingAndDeliveryPolicies2'] }}
              {{ accountSlug }}{{ translations['contentShippingAndDeliveryPolicies3'] }}
            </p>
          </div>
        </div>

        <div class="col-12" *ngIf="selectedTab === 'privacy'">
          <div class="bg-transparent">
            <h5 class="font-bold text-justify mb-3 text-xl text-primary">{{ translations['titlePrivacyPolicies'] }}</h5>
            <p class="text-justify mb-3 m-0 text-500">
              {{ translations['contentPrivacyPolicies1'] }}
              {{ accountSlug }}{{ translations['contentPrivacyPolicies2'] }} {{ accountSlug
              }}{{ translations['contentPrivacyPolicies3'] }} {{ accountSlug
              }}{{ translations['contentPrivacyPolicies4'] }} {{ accountSlug
              }}{{ translations['contentPrivacyPolicies5'] }} {{ accountSlug }}
              {{ translations['contentPrivacyPolicies6'] }} {{ accountSlug }}
              {{ translations['contentPrivacyPolicies7'] }} {{ accountSlug }}
              {{ translations['contentPrivacyPolicies8'] }} {{ accountSlug }}
              {{ translations['contentPrivacyPolicies9'] }} {{ accountSlug }}
              {{ translations['contentPrivacyPolicies10'] }}
            </p>
          </div>
        </div>
      </div>
    </app-scroll-container>
  </div>
</app-juvo-dialog>
